import { render, staticRenderFns } from "./AirdropSetting.vue?vue&type=template&id=6c49bb8a&scoped=true"
import script from "./AirdropSetting.vue?vue&type=script&lang=js"
export * from "./AirdropSetting.vue?vue&type=script&lang=js"
import style0 from "./AirdropSetting.vue?vue&type=style&index=0&id=6c49bb8a&prod&lang=scss&scoped=true"
import style1 from "./AirdropSetting.vue?vue&type=style&index=1&id=6c49bb8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c49bb8a",
  null
  
)

export default component.exports